export default __webpack_public_path__ + "static/media/favicon.3f70f8fa.ico";